import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SiteSiftLogo from './brand/SiteSiftLogo';

export default function PublicNav({ scrolled = false }) {
  const navigate = useNavigate();
  const location = useLocation();

  const homeActive = location.pathname === '/';
  const pricingActive = location.pathname === '/pricing';
  const loginActive = location.pathname === '/login';

  const goHome = () => {
    if (homeActive) {
      const page = document.querySelector('.landing-page');
      if (page && typeof page.scrollTo === 'function') {
        page.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    navigate('/');
  };

  return (
    <nav className={`landing-nav-pill ${scrolled ? 'scrolled' : ''}`} aria-label="Primary">
      <div className="landing-nav-pill-inner">
        <button
          type="button"
          aria-label="SiteSift.AI Home"
          onClick={goHome}
          className={`landing-nav-pill-brand ${homeActive ? 'active' : ''}`}
        >
          <SiteSiftLogo height={38} tone={homeActive ? 'dark' : 'light'} />
        </button>
        <div className="landing-nav-pill-divider" />
        <button
          type="button"
          onClick={() => navigate('/pricing')}
          className={`landing-nav-pill-link ${pricingActive ? 'active' : ''}`}
        >
          Pricing
        </button>
        <div className="landing-nav-pill-divider" />
        <button
          type="button"
          onClick={() => navigate('/login')}
          className={`landing-nav-pill-link ${loginActive ? 'active' : ''}`}
        >
          Sign in
        </button>
      </div>
    </nav>
  );
}
